import { render, staticRenderFns } from "./SpecialistPackItem.vue?vue&type=template&id=093e9cca&scoped=true&"
import script from "./SpecialistPackItem.vue?vue&type=script&lang=ts&"
export * from "./SpecialistPackItem.vue?vue&type=script&lang=ts&"
import style0 from "./SpecialistPackItem.vue?vue&type=style&index=0&id=093e9cca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093e9cca",
  null
  
)

export default component.exports